/**
 * @generated SignedSource<<949e2393b5187a11785cc279b19b9d65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteMeeting_note$data = {
  readonly id: string;
  readonly isLocked: boolean;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteNoteModal_note" | "MenuItemTooltip_useGetPropsForExternalWorkspaces_note">;
  readonly " $fragmentType": "DeleteMeeting_note";
};
export type DeleteMeeting_note$key = {
  readonly " $data"?: DeleteMeeting_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteMeeting_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteMeeting_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MenuItemTooltip_useGetPropsForExternalWorkspaces_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteNoteModal_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "5daa35cd0f3818e8601d39476a3cb162";

export default node;
